/** Çalışma zamanı konfigürasyonu — /config.json'dan okunur (build-time env yok). */
export interface RuntimeConfig {
  dalUrl: string;
  nodeUrl: string;
  appId: string;
  docsUrl: string;
  appVersion: string;
  features: { aiChat: boolean; chat: boolean };
}

const DEFAULTS: RuntimeConfig = {
  dalUrl: '',
  nodeUrl: '',
  appId: 'Octo.Web',
  docsUrl: 'https://docs.reniumglobal.com',
  appVersion: 'dev',
  features: { aiChat: true, chat: true },
};

let current: RuntimeConfig = DEFAULTS;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) {
      const json = (await res.json()) as Partial<RuntimeConfig>;
      current = { ...DEFAULTS, ...json, features: { ...DEFAULTS.features, ...(json.features ?? {}) } };
    }
  } catch {
    /* config yoksa varsayılanlar */
  }
  if (!current.dalUrl) current.dalUrl = window.location.origin;
  current.dalUrl = current.dalUrl.replace(/\/+$/, '');
  return current;
}

export function runtimeConfig(): RuntimeConfig {
  return current;
}
